import React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgInfo = (props) => {
    const { color } = props;
    return (React.createElement("path", { fill: color, fillRule: "evenodd", d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm1-4a1 1 0 0 1-2 0v-4a1 1 0 0 1 2 0v4zm-1-7a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" }));
};
export default factorySvgIcon(SvgInfo);
//# sourceMappingURL=SvgInfo.js.map